import React from "react";

import Footer from "../components/Footer";

import {
  Link,
} from "react-router-dom";

import ResumenViajesHome from "../components/ResumenViajesHome";

import {
  FaTruck,
  FaShieldAlt,
  FaMoneyBillWave,
  FaExchangeAlt,
  FaFileInvoiceDollar,
  FaUserPlus,
  FaChartBar,
  FaInfoCircle,
  FaChevronRight,
  FaArrowDown,
  FaReceipt,
  FaRoad,
} from "react-icons/fa";

import papas from "../images/bolsa.png";
import peaje from "../images/peaje.png";
import logo from "../images/DANLU_logo_transparent.png";

import "../css/home.css";

/* =========================================================
   ACCESOS PRINCIPALES
========================================================= */

const accesos = [
  {
    to: "/comandas",
    titulo: "Viajes",
    descripcion:
      "Gestión de viajes, rutas y documentación",
    icono: FaTruck,
    clase: "viajes",
  },

  {
    to: "/remitos",
    titulo: "Papas",
    descripcion:
      "Control de cargas y descargas de papas",
    imagen: papas,
    clase: "papas",
  },

  {
    to: "/peajes",
    titulo: "Peajes",
    descripcion:
      "Consumos, facturación, conciliación y pagos",
    imagen: peaje,
    clase: "peajes destacado-azul",
  },

  {
    to: "/seguros",
    titulo: "Seguros",
    descripcion:
      "Pólizas, vehículos, vencimientos y pagos",
    icono: FaShieldAlt,
    clase: "seguros destacado-verde",
  },

  {
    to: "/cajas",
    titulo: "Cajas",
    descripcion:
      "Fondos, gastos y control de cajas",
    icono: FaMoneyBillWave,
    clase: "cajas",
  },

  {
    to: "/movimientos",
    titulo: "Movimientos",
    descripcion:
      "Ingresos, egresos y transferencias",
    icono: FaExchangeAlt,
    clase: "movimientos",
  },

  {
    to: "/viajes",
    titulo: "Rendiciones",
    descripcion:
      "Rendición de gastos y comprobantes",
    icono: FaFileInvoiceDollar,
    clase: "rendiciones",
  },

  {
    to: "/HomeAltas",
    titulo: "Altas",
    descripcion:
      "Gestión de altas del sistema",
    icono: FaUserPlus,
    clase: "altas",
  },

  {
    to: "/HomeImpresion",
    titulo: "Informes",
    descripcion:
      "Reportes y análisis de información",
    icono: FaChartBar,
    clase: "informes",
  },

  {
    to: "/AcercaDe",
    titulo: "Acerca de",
    descripcion:
      "Información del sistema y ayuda",
    icono: FaInfoCircle,
    clase: "acerca",
  },
];

/* =========================================================
   CARD GENERAL
========================================================= */

const ModuloCard = ({
  item,
}) => {
  const Icono =
    item.icono;

  return (
    <Link
      to={item.to}
      className={`danlu-module-card ${item.clase}`}
    >
      <div className="danlu-module-icon">
        {item.imagen ? (
          <img
            src={item.imagen}
            alt={item.titulo}
          />
        ) : (
          <Icono />
        )}
      </div>

      <div className="danlu-module-body">
        <h3>
          {item.titulo}
        </h3>

        <p>
          {
            item.descripcion
          }
        </p>
      </div>

      <div className="danlu-module-arrow">
        <FaChevronRight />
      </div>
    </Link>
  );
};

/* =========================================================
   HOME
========================================================= */

const Home = () => {
  return (
    <div className="danlu-home danlu-home-con-resumen">
      {/* =================================================
          HERO
      ================================================= */}

      <section className="danlu-hero">
        <div className="danlu-hero-content">
          <span className="danlu-eyebrow">
            BIENVENIDO A
          </span>

          <h1>
            Gestión de Datos
          </h1>

          <p>
            Accesos rápidos a los módulos
            principales del sistema
          </p>
        </div>

        <div className="danlu-hero-visual">
          <img
            src={logo}
            alt="Transporte DANLU"
          />

          <div className="danlu-hero-slogan">
            <span>
              MOVIENDO
            </span>

            <span>
              TU PRODUCCIÓN
            </span>

            <span>
              SIEMPRE MÁS LEJOS
            </span>

            <div className="danlu-slogan-line" />
          </div>
        </div>
      </section>

      <ResumenViajesHome />

      {/* =================================================
          ACCESOS
      ================================================= */}

      <section className="danlu-module-grid">
        {accesos.map(
          (item) => (
            <ModuloCard
              key={
                item.to
              }
              item={
                item
              }
            />
          )
        )}
      </section>

      {/* =================================================
          MÓDULOS DESTACADOS
      ================================================= */}

      <section className="danlu-feature-grid">
        {/* ===============================================
            PEAJES
        =============================================== */}

        <div className="danlu-feature danlu-feature-peajes">
          <div className="danlu-feature-header">
            <div className="danlu-feature-main-icon">
              <img
                src={peaje}
                alt="Peajes"
              />
            </div>

            <div>
              <h2>
                Gestión de Peajes
              </h2>

              <p>
                Consumos,
                facturación,
                conciliación y
                pagos
              </p>
            </div>
          </div>

          <div className="danlu-feature-links">
            <Link
              to="/importarpeajes"
              className="danlu-feature-link"
            >
              <span className="danlu-feature-link-icon">
                <FaArrowDown />
              </span>

              <span className="danlu-feature-link-text">
                <strong>
                  Importar consumos
                </strong>

                <small>
                  Carga de consumos
                  de peajes
                </small>
              </span>

              <FaChevronRight className="danlu-mini-arrow" />
            </Link>

            <Link
              to="/resumenespeajes"
              className="danlu-feature-link"
            >
              <span className="danlu-feature-link-icon">
                <FaReceipt />
              </span>

              <span className="danlu-feature-link-text">
                <strong>
                  Resúmenes y pagos
                </strong>

                <small>
                  Facturación y
                  gestión de pagos
                </small>
              </span>

              <FaChevronRight className="danlu-mini-arrow" />
            </Link>

            <Link
              to="/informepeajes"
              className="danlu-feature-link"
            >
              <span className="danlu-feature-link-icon">
                <FaChartBar />
              </span>

              <span className="danlu-feature-link-text">
                <strong>
                  Informe de peajes
                </strong>

                <small>
                  Reportes y análisis
                  de peajes
                </small>
              </span>

              <FaChevronRight className="danlu-mini-arrow" />
            </Link>
          </div>
        </div>

        {/* ===============================================
            SEGUROS
        =============================================== */}

        <div className="danlu-feature danlu-feature-seguros">
          <div className="danlu-feature-header">
            <div className="danlu-feature-main-icon">
              <FaShieldAlt />
            </div>

            <div>
              <h2>
                Gestión de Seguros
              </h2>

              <p>
                Pólizas, vehículos,
                vencimientos,
                facturación y pagos
              </p>
            </div>
          </div>

          <div className="danlu-feature-links seguros-links">
            <Link
              to="/polizasseguros"
              className="danlu-feature-link"
            >
              <span className="danlu-feature-link-icon">
                <FaFileInvoiceDollar />
              </span>

              <span className="danlu-feature-link-text">
                <strong>
                  Pólizas y facturación
                </strong>

                <small>
                  Administración de
                  pólizas y pagos
                </small>
              </span>

              <FaChevronRight className="danlu-mini-arrow" />
            </Link>

            <Link
              to="/informeseguros"
              className="danlu-feature-link"
            >
              <span className="danlu-feature-link-icon">
                <FaChartBar />
              </span>

              <span className="danlu-feature-link-text">
                <strong>
                  Informe de seguros
                </strong>

                <small>
                  Reportes y análisis
                  de seguros
                </small>
              </span>

              <FaChevronRight className="danlu-mini-arrow" />
            </Link>
          </div>
        </div>
      </section>

      {/* =================================================
          FOOTER HOME
      ================================================= */}
      <Footer />
    </div>
  );
};

export default Home;